import { render, staticRenderFns } from "./WorkTransfer.vue?vue&type=template&id=bb13375e&scoped=true"
import script from "./WorkTransfer.vue?vue&type=script&lang=js"
export * from "./WorkTransfer.vue?vue&type=script&lang=js"
import style0 from "./WorkTransfer.vue?vue&type=style&index=0&id=bb13375e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb13375e",
  null
  
)

export default component.exports